import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
    locales: ['cs', 'en', 'es', 'ro', 'pl'],
    defaultLocale: 'cs',
    // 'as-needed' keeps the default locale (cs) unprefixed — preserves the
    // existing URL structure (cs at root, /en /es /ro /pl for the rest).
    localePrefix: 'as-needed',
});

export type Locale = (typeof routing.locales)[number];
